import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDropzone } from 'react-dropzone'

import PrimaryButton from '@components/inputs/button/primaryButton'
import SubText from '@components/text/subText'
import showToast from '@util/ToastUtil'

import {
  Container,
  DropContainer,
  Title,
  Description,
  Icon,
  ButtonContainer,
  FilesContainer,
  Header,
  Ul,
  Li,
  LiItem,
  Remove,
} from './styles'

import colors from '@settings/styleSettings'
import 'material-icons/iconfont/outlined.css'

const maxFiles = 50
const DropzoneComponent = ({ files, setFiles }) => {
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles?.length && (files.length + acceptedFiles.length) <= maxFiles) {
      setFiles((previousFiles) => {
        const existingFileNames = new Set(
          previousFiles.map((file) => file.name)
        )

        const newFiles = acceptedFiles.filter(
          (file) => !existingFileNames.has(file.name)
        )

        return [
          ...previousFiles,
          ...newFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) })),
        ]
      })
    } else {
      showToast('error', 'Limite de arquivos atingido')
    }
  }, [files])

  const {
    getRootProps,
    getInputProps,
    open
  } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true,
    maxFiles,
    accept: {
      'application/pdf': ['.pdf'],
    },
  })

  const removeFile = (idx) => {
    const aux = files
    aux.splice(idx, 1)
    setFiles([...aux])
  }

  const confirmFile = () => { }

  const acceptedFileItems = files.map((file, idx) => (
    <Li key={file.name}>
      <LiItem>
        <span
          className="material-symbols-outlined"
          style={{
            color: colors.strongGray,
            margin: '0 16px',
          }}
        >
          lab_profile
        </span>
        {file.name}
      </LiItem>
      <LiItem>
        <span
          className="material-symbols-outlined"
          style={{
            color: colors.primary,
            margin: '0 16px',
            cursor: 'pointer',
          }}
          onClick={confirmFile}
        >
          check
        </span>
        <Remove onClick={() => removeFile(idx)}>Remover</Remove>
      </LiItem>
    </Li>
  ))

  const listFiles = () => (
    <FilesContainer>
      <input {...getInputProps()} />
      <Header>
        <PrimaryButton
          onClick={open}
          style={{
            width: '200px',
            backgroundColor: colors.background,
            color: colors.strongGray,
            border: `1px solid ${colors.strongGray}`,
          }}
        >
          <span
            className="material-symbols-outlined"
            style={{
              color: colors.strongGray,
              marginRight: '8px',
            }}
          >
            add
          </span>
          Adicionar arquivos
        </PrimaryButton>

        <p style={{ color: colors.strongGray, fontWeight: 'bold' }}>
          {files.length}
          {' '}
          /
          {' '}
          {maxFiles && maxFiles}
          {' '}
          arquivos adicionados
        </p>
      </Header>

      <div>
        <Ul>{acceptedFileItems}</Ul>
      </div>
    </FilesContainer>
  )

  const addFiles = () => (
    <DropContainer>
      <input {...getInputProps()} />
      <Icon className="material-icons-outlined">assignment</Icon>
      <Title>Você ainda não anexou nenhum arquivo</Title>
      <ButtonContainer>
        <PrimaryButton onClick={open}>Procurar no computador</PrimaryButton>

        <SubText style={{ color: colors.titleStrongBlack }}>
          ou arraste os arquivos para cá...
        </SubText>
      </ButtonContainer>
      <Description>
        Apenas arquivos do tipo PDF com tamanho máximo de 50 MB são aceitos,
        gerados através do Sistema Jalis.
      </Description>
    </DropContainer>
  )

  return (
    <Container
      {...getRootProps({ className: 'dropzone' })}
    >
      {files.length > 0 ? <Container>{listFiles(getInputProps)}</Container>
        : <Container>{addFiles(getInputProps)}</Container>}
    </Container>
  )
}
export default DropzoneComponent

DropzoneComponent.propTypes = {
  className: PropTypes.string,
  files: PropTypes.array,
  setFiles: PropTypes.func.isRequired,
}

DropzoneComponent.defaultProps = {
  className: '',
  files: [],
}
